export const BugBlueIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
      <defs />
      <title>{"flying-insect-ladybug"}</title>
      <path d="M16,6.436V4.5a4,4,0,0,0-8,0V6.436" fill="#00e6ca" />
      <path
        d="M12,.5a4,4,0,0,0-4,4V6.436h.04a3.977,3.977,0,0,1,7.92,0H16V4.5A4,4,0,0,0,12,.5Z"
        fill="#00e6ca"
      />
      <path
        d="M16,6.436V4.5a4,4,0,0,0-8,0V6.436"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle cx={12} cy={14.5} r={9} fill="#c4f0eb" />
      <path d="M12,19.115a9,9,0,0,1-8.72-6.808,9,9,0,1,0,17.44,0A9,9,0,0,1,12,19.115Z" fill="#00e6ca" />
      <line
        x1={9.115}
        y1={1.73}
        x2={8.5}
        y2={0.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={14.885}
        y1={1.73}
        x2={15.5}
        y2={0.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={12}
        cy={14.5}
        r={3.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#00e6ca"
      />
      <path
        d="M17.319,21.75a2.5,2.5,0,0,1,3-3.793"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.286,10.98a2.679,2.679,0,0,1-1.036.228,2.5,2.5,0,0,1-2-4"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#00e6ca"
      />
      <path
        d="M6.719,21.789a2.629,2.629,0,0,0,.532-1.541,2.5,2.5,0,0,0-2.5-2.5A2.763,2.763,0,0,0,3.7,17.98"
        fill="#00e6ca"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.713,10.983a2.677,2.677,0,0,0,1.037.225,2.5,2.5,0,0,0,2-4"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="#00e6ca"
      />
      <polyline
        points="18.383 8.156 20 6 21.5 6"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <polyline
        points="18.391 20.837 19.5 22.5 21 22.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <polyline
        points="5.617 8.156 4 6 2.5 6"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <polyline
        points="5.609 20.837 4.5 22.5 3 22.5"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={20.678}
        y1={12.107}
        x2={22.5}
        y2={11.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={20.792}
        y1={16.431}
        x2={22.5}
        y2={17}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={3.322}
        y1={12.107}
        x2={1.5}
        y2={11.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={3.208}
        y1={16.431}
        x2={1.5}
        y2={17}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.25,3a.25.25,0,0,1,.25.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10,3.25A.25.25,0,0,1,10.25,3"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.25,3.5A.25.25,0,0,1,10,3.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M10.5,3.25a.25.25,0,0,1-.25.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.75,3a.25.25,0,0,1,.25.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.5,3.25A.25.25,0,0,1,13.75,3"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M13.75,3.5a.25.25,0,0,1-.25-.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M14,3.25a.25.25,0,0,1-.25.25"
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <circle
        cx={12}
        cy={14.5}
        r={9}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <line
        x1={12}
        y1={5.5}
        x2={12}
        y2={23.5}
        stroke="#0f172a"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};
